import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY}.${BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.ORGANIZATION_AND_TEAM}` as const;

export const EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES = {
  MEMBERS: 'members',
} as const;

export interface IOrganizationAndTeamExecutiveSummaryForm {
  [EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES.MEMBERS]: string;
}

export const organizationAndTeamExecutiveSummaryInitialValues: IOrganizationAndTeamExecutiveSummaryForm = {
  [EXECUTIVE_SUMMARY_ORGANIZATION_AND_TEAM_NAMES.MEMBERS]: '',
};
